{
  "de": {
    "sharedLibrary": {
      "title": "Gemeinsame Ablage",
      "subline": "Hier stellt euer Kollegium Vorlagen für den Schulalltag bereit – sichtbar nur für deine Schule.\nKopiere, was du brauchst, und ergänze, was anderen hilft.",
      "tutorial": "Tutorial ansehen",
      "paused": {
        "title": "Die Gemeinsame Ablage ist pausiert",
        "text": "Die Schullizenz ist nicht mehr aktiv, Materialien bleiben aber erhalten.\nSobald deine Schule eine Lizenz hat, hast du wieder Zugriff.",
        "activationLink": "Neuen Aktivierungscode eingeben",
        "modalTitle": "Aktivierungscode eingeben",
        "codeLabel": "Aktivierungscode der Schullizenz",
        "codePlaceholder": "Code der Schullizenz eingeben…",
        "success": "Schullizenz aktiviert! Du bist jetzt Mitglied von „{groupTitle}“."
      },
      "createMenu": {
        "createNew": "Neu erstellen",
        "importFromMyContent": "Aus Meiner Ablage kopieren",
        "shareContent": "Inhalte teilen"
      },
      "importDialog": {
        "title": "Aus Meiner Ablage kopieren",
        "tabLabel": "Meine Ablage",
        "searchPlaceholder": "Suchbegriff…",
        "confirm": "Kopieren",
        "empty": "Keine Inhalte gefunden.",
        "emptyFolder": "Dieser Ordner ist leer.",
        "errorLoading": "Deine Inhalte konnten nicht geladen werden."
      },
      "search": {
        "placeholder": "Gemeinsame Ablage durchsuchen..."
      },
      "actions": {
        "copyToMyContent": "In Meine Ablage kopieren",
        "copyToMyContentPending": "Wird in Meine Ablage kopiert …",
        "copyToSharedLibrary": "In Gemeinsame Ablage kopieren"
      },
      "folderNotSupported": {
        "title": "Ordner können noch nicht in die Gemeinsame Ablage kopiert werden",
        "selectionHint": "Wähle die Inhalte im Ordner aus und kopiere sie einzeln oder gemeinsam."
      },
      "copyDialog": {
        "title": "In Gemeinsame Ablage kopieren",
        "school": "Schule",
        "folder": "Ordner",
        "createFolder": "Neuen Ordner anlegen",
        "newFolderName": "Name des neuen Ordners",
        "folderLoadError": "Die Ordner konnten nicht geladen werden. Bitte versuche es erneut."
      },
      "moveDialog": {
        "mixedSelection": "Die ausgewählten Inhalte liegen in verschiedenen Ablagen. Verschieben ist nur innerhalb einer Ablage möglich – wähle Inhalte aus nur einer Ablage aus."
      },
      "copyResult": {
        "success": "Inhalt wurde erfolgreich in die Gemeinsame Ablage kopiert",
        "failure": "Deine Auswahl konnte nicht in die Gemeinsame Ablage kopiert werden",
        "retry": "Bitte versuche es erneut.",
        "responsesNotCopied": "Die Abgaben deiner Schüler*innen werden nicht kopiert"
      },
      "adoptDialog": {
        "title": "In Meine Ablage kopieren",
        "folder": "Ordner"
      },
      "adoptResult": {
        "success": "Inhalt wurde erfolgreich in Meine Ablage kopiert",
        "failure": "Deine Auswahl konnte nicht in Meine Ablage kopiert werden"
      },
      "schoolSelect": {
        "ariaLabel": "Schule wechseln",
        "hint": "Hier kannst du deine Schule auswählen"
      },
      "links": {
        "backToLibrary": "Zur Gemeinsamen Ablage",
        "trash": "Papierkorb ansehen"
      },
      "emptyState": {
        "root": "Bisher sind noch keine Inhalte in der Gemeinsamen Ablage deiner Schule.",
        "folder": "Es gibt aktuell keine Inhalte in diesem Ordner."
      },
      "noAccess": {
        "noSchool": {
          "title": "Du gehörst noch zu keiner Schule",
          "text": "Die Gemeinsame Ablage gehört immer zu einer Schule. Sobald du einer Schule zugeordnet bist, findest du hier die Materialien deines Kollegiums."
        },
        "disabledBySchool": {
          "title": "Deine Schule hat die Gemeinsame Ablage deaktiviert",
          "text": "Für deine Schule ist die Gemeinsame Ablage ausgeschaltet. Wende dich an die Lizenzverwaltung deiner Schule, wenn ihr sie wieder nutzen möchtet."
        },
        "refusedBySchool": {
          "title": "Diese Gemeinsame Ablage steht dir nicht mehr offen",
          "text": "Deine Schule gibt diese Gemeinsame Ablage gerade nicht für dich frei. Das passiert, wenn deine Mitgliedschaft beendet wurde oder deine Schule die Gemeinsame Ablage deaktiviert hat. Lade die Seite neu oder wende dich an die Lizenzverwaltung deiner Schule."
        }
      },
      "copySelectionDialog": {
        "title": "Auswahl in Gemeinsame Ablage kopieren",
        "school": "Schule",
        "createFolder": "Neuen Ordner anlegen",
        "newFolderName": "Name des neuen Ordners"
      },
      "trash": {
        "heading": "Papierkorb",
        "buttons": {
          "clear": "Papierkorb leeren"
        },
        "emptyTable": "Es gibt aktuell keine entfernten Inhalte in der Gemeinsamen Ablage deiner Schule.",
        "subline": "Gelöschte Materialien und Ordner bleiben <strong>30 Tage</strong> im Papierkorb. Bis dahin können sie wiederhergestellt werden, danach werden sie endgültig entfernt."
      },
      "preview": {
        "loadError": "Der Inhalt konnte nicht geladen werden.",
        "noTask": "Es ist kein Arbeitsauftrag hinterlegt.",
        "noWords": "Es wurden noch keine Wörter eingegeben.",
        "qrCodeAlt": "QR-Code für {url}",
        "targetUrl": "Ziel-URL",
        "type": "Typ"
      }
    }
  }
}
